<!-- 饼图 -->
<style lang="stylus" scoped>
.circleBar
  height 250px
  .main
    width 100%
    height 100%
</style>

<template>
  <boxWrap :name="name">
    <div class="circleBar">
      <div class="main"></div>
    </div>
  </boxWrap>
</template>

<script>
import echarts from 'echarts'
import boxWrap from 'components/dashboard/common/boxWrap';
export default {
  data() {
    return {
      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
      myChart2: {},
      name: '农安信用数据构成',
      circleBarData: [
        {value: 19.05, name: '质量安全评估信息'},
        {value: 4.76, name: '其他信息'},
        {value: 14.29, name: '奖励信息'},
        {value: 9.52, name: '监督检查信息'},
        {value: 14.29, name: '认证(登记)信息'},
        {value: 14.28, name: '行政处罚'},
        {value: 19.05, name: '行政许可信息'},
        {value: 9.52, name: '基础信息'}
      ]
    }
  },
  components: {
    boxWrap
  },
  methods: {
    init() {
      window.addEventListener('resize', function() {
        this.myChart.resize()
      }.bind(this))
    }
  },
  mounted() {
    // 基于准备好的dom，初始化echarts实例
    this.myChart2 = echarts.init(document.querySelector('.circleBar .main'));
    this.myChart2.setOption({
      tooltip: {
        show: false
      },
      legend: {
        show: false
      },
      color: this.color,
      series: [
        {
          type: 'pie',
          selectedMode: 'single',
          radius: [0, '40%'],
          label: {
            normal: {
              show: false,
              position: 'inner',
              formatter: '{d}%',
              textStyle: {
                color: '#fff',
                fontWeight: 'normal',
                fontSize: 20
              }
            }
          },
          labelLine: {
            normal: {
              show: false
            }
          },
          data: this.circleBarData
        },
        {
          type: 'pie',
          radius: ['50%', '55%'],
          label: {
            normal: {
              formatter: '{b|{b}}\n{hr|}\n{d|{d}%}',
              rich: {
                b: {
                  fontSize: 14,
                  color: '#fff',
                  align: 'left',
                  padding: 4
                },
                hr: {
                  borderColor: '#12EABE',
                  width: '100%',
                  borderWidth: 2,
                  height: 0
                },
                d: {
                  fontSize: 14,
                  color: '#fff',
                  align: 'left',
                  padding: 4
                },
                c: {
                  fontSize: 14,
                  color: '#fff',
                  align: 'center',
                  padding: 4
                }
              }
            }
          },
          labelLine: {
            normal: {
              show: true,
              length: 20,
              length2: 20
            }
          },
          data: this.circleBarData
        }
      ]
    })
  }
}

</script>



// WEBPACK FOOTER //
// index.vue?77a3af16